import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

function MemberNames({ id, members, conversationName, isMobile, isTablet }) {
  const { t } = useTranslation()
  const [names, setNames] = useState('')
  useEffect(() => {
    if (conversationName) {
      setNames(conversationName)
    } else {
      let conversationLable = ''
      if (members.length === 1) {
        if (members[0].status === 'deleted') {
          conversationLable = t('global.deletedUser')
        } else {
          conversationLable = members[0].firstname + ' ' + members[0].lastname
        }
      } else if (members.length === 2) {
        conversationLable = members
          .map((member) => {
            if (member.is_logged_user) {
              return
            }
            if (member.status === 'deleted') {
              return t('global.deletedUser')
            } else {
              return member.firstname + ' ' + member.lastname
            }
          })
          .join(' & ')
      } else if (members.length === 3) {
        const updatedName = members.reduce((prevVal, member, index) => {
          const lastChar = index === 0 ? ', ' : index === 1 ? ' & ' : ''
          if (member.status === 'deleted') {
            return `${prevVal} ${t('global.deletedUser')}`
          } else {
            return `${prevVal} ${member.firstname} ${
              member.lastname ? `${member.lastname.charAt(0).toUpperCase()}.${lastChar}` : lastChar
            }`
          }
        }, '')
        conversationLable = updatedName
      } else {
        const diplayNameCount = isMobile ? 2 : isTablet ? 4 : 6
        const remainingCount = members.length - diplayNameCount
        conversationLable = members
          .filter((member, index) => index < diplayNameCount)
          .map((member) => {
            if (member.status === 'deleted') {
              return t('global.deletedUser')
            } else {
              return `${member.firstname} ${member.lastname ? `${member.lastname.charAt(0).toUpperCase()}.` : ''}`
            }
          })
          .join(', ')
        if (remainingCount > 0) {
          if (remainingCount === 1) {
            conversationLable = t('messenger.header.conversationMembersLabel1More', {
              conversationLabel: conversationLable,
              remainingCount
            })
          } else {
            conversationLable = t('messenger.header.conversationMembersLabelOthers', {
              conversationLabel: conversationLable,
              remainingCount
            })
          }
        }
      }
      setNames(conversationLable)
    }
  }, [id, conversationName])
  return <React.Fragment>{names}</React.Fragment>
}

export default MemberNames
